var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.545 8.239V12.06H15.99C15.278 14.375 13.343 16.032 10.545 16.032C7.21297 16.032 4.51197 13.331 4.51197 10C4.51197 6.669 7.21297 3.968 10.545 3.968C12.043 3.968 13.411 4.517 14.466 5.421L17.28 2.607C15.503 0.988 13.139 0 10.545 0C5.02097 0 0.542969 4.477 0.542969 10C0.542969 15.523 5.02097 20 10.545 20C18.941 20 20.794 12.15 19.971 8.252L10.545 8.239Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.9fb3a13b1a7d5de45cb558dc58eb38ee.svg";
export { ForwardRef as ReactComponent };